import OARequest from '@/service/request/OA-Base'

export function GetWxAuth(params) {
  return OARequest.get({
    url: 'Navigate/GetWxAuth',
    params
  })
}

export function getTicket(params) {
  return OARequest.get({
    url: 'auth/JSTicket',
    params
  })
}

export function GetUserQRCode(data) {
  return OARequest.post({
    url: 'Navigate/GetUserQRCode',
    data
  })
}
